import { Directive, ElementRef, Renderer2, AfterViewChecked } from '@angular/core';

@Directive({
  selector: '[autoResizeFont]'
})
export class AutoResizeFontDirective implements AfterViewChecked {
  constructor(private readonly el: ElementRef, private readonly renderer: Renderer2) {}

  ngAfterViewChecked() {
    this.adjustFontSizeForChildren();
  }

  private adjustFontSizeForChildren() {
    const element = this.el.nativeElement;
    const children = element.children;
    for (let i = 0; i < children.length; i++) {
      let child = children[i]
      const divHeight = element.clientHeight;
      const divWidth = element.clientWidth;
      let fontSize = divWidth / 3.5;
      if (child.classList.contains('subtitle')) {
        let font = (divHeight * 0.5 < fontSize ? divHeight * 0.15 : fontSize * 0.25)
       this.renderer.setStyle(child, 'font-size', font + 'px');
      }
      if(child.classList.contains('text-font')) {
       this.renderer.setStyle(child, 'font-size', (divHeight * 0.5 < fontSize ? divHeight * 0.35 : fontSize * 0.6) + 'px');
      }
    }
  }
}